const isRequired = require('../../../utilities/isRequired');

const decimalRound = (num = isRequired(), decimals = isRequired()) => Math
    .round(num * (10 ** decimals)) / (10 ** decimals);

module.exports = decimalRound;
